import React, { Component } from 'react';
import './Component.css';
import Treemap from './Treemap/Treemap.jsx';
import ReadMore from './ReadMore/ReadMore.jsx';
import { getText } from './AllTexts.jsx';

class ScaleNational extends Component {
	render() {
		return (
			<div className="Scale-National Component" id="national">
				<div className="text">
					<p className="title">{getText('scale-national-title')}</p>
					{getText('scale-national-intro')}
				</div>
				<div className="graphic">
					<Treemap
						width={this.props.width}
						height={this.props.height}
						year={this.props.params.treeCanadaPermanent.year}
						category={this.props.params.treeCanadaPermanent.category}
						city='canada'
						update={this.props.update.treeCanadaPermanent}
						type='permanent' />
				</div>
				<div className="text">
				 {getText('scale-national-temporary-migrants')}
				</div>
				<div className="graphic">
					<Treemap
						width={this.props.width}
						height={this.props.height}
						year={this.props.params.treeCanadaTemporary.year}
						category={this.props.params.treeCanadaTemporary.category}
						city='canada'
						update={this.props.update.treeCanadaTemporary}
						type='temporary' />
				</div>
			</div>
		);
	}
}

export default ScaleNational;



// WEBPACK FOOTER //
// ./src/ScaleNational.jsx